import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import axios from 'axios'
import ReactDOM from 'react-dom'
import { compose } from 'recompose'
import { push } from 'react-router-redux'

// Styles
import styles from './styles'

// Material UI
import { withStyles } from 'material-ui/styles'
import Typography from 'material-ui/Typography'
import Dialog, {
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from 'material-ui/Dialog'

// Components
import Item from '../../../../../../../../../../components/Item'
import Loader from '../../../../../../../../../../components/Loader'

// Actions
import { loadedSavedData, removeSavedData } from './actions'

// Algolia
import * as algoliasearch from 'algoliasearch'
var client = algoliasearch('5B2G72ZK2N', '1aaebeea6fc4b1dd6695ee42d9d823c1')

const applyUpdateResult = (result, page) => prevState => ({
  data: [...prevState.data, ...result.data],
  page: result.page,
  isError: false,
  isLoading: false
})

const applySetResult = (result, page) => prevState => ({
  data: result.data,
  page: result.page,
  isError: false,
  isLoading: false
})

const applySetError = prevState => ({
  isError: true,
  isLoading: false
})

class Results extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      data: [],
      page: null,
      isLoading: false,
      isError: false,
      classes: this.props.classes,
      loadedInitialData: false,
      url: '',
      hits: []
    }
  }

  onPaginatedSearch = e => this.fetchStories(this.state.page + 1)

  fetchStories = page => {
    this.setState({ isLoading: true })
    let myComponent = this
    console.log('load next')
    let itemsRequired = 0
    if (page > 0) {
      itemsRequired = this.state.data.length + 1
    }
    console.log(itemsRequired)

    var urlParams = new URLSearchParams(window.location.search)
    var myParam = urlParams.get('query').replace('%20', '')

    let saved_search_id = urlParams.get('saved_search_id').replace('%20', '')

    var index = client.initIndex('Candidates')

    index.search(
      {
        query: `${myParam}`,
        offset: itemsRequired,
        length: 40
      },
      function searchDone(err, content) {
        let response = {}
        response.data = content.hits
        if (Array.isArray(response.data)) {
          if (response.data.length == 0) {
            if (myComponent.state.data.length == 0) {
              alert('No Results. Tap Ok to be taken back.')
              window.history.go(-1)
            }
          } else {
            response.page = page
            myComponent.onSetResult(response, page)
            myComponent.props.loadedSavedData(myComponent.state.data)
            myComponent.setState(
              {
                loadedInitialData: true
              },
              function() {
                window.scrollTo(0, 0)
              }
            )
          }
        } else {
          myComponent.fetchStories(page)
        }
      }
    )
  }

  onSetResult = (result, page) =>
    page === 0
      ? this.setState(applySetResult(result, page))
      : this.setState(applyUpdateResult(result, page))

  onSetError = () => this.setState(applySetError)

  componentDidMount() {
    this.fetchStories(0)
    window.scrollTo(0, 0)
  }

  componentWillUnmount() {
    this.props.removeSavedData()
  }

  render() {
    const { classes } = this.props
    return (
      <div>
        <div className={classes.items}>
          <AdvancedList
            list={this.state.data}
            isError={this.state.isError}
            isLoading={this.state.isLoading}
            page={this.state.page}
            onPaginatedSearch={this.onPaginatedSearch}
          />
        </div>
        <div>{!this.state.loadedInitialData && <Loader />}</div>
      </div>
    )
  }
}

const List = ({ list }) => (
  <div className="list">
    {list.map(item => (
      <div className="list-row" key={item['access id']}>
        <Item data={item} />
      </div>
    ))}
  </div>
)

const withLoading = conditionFn => Component => props => {
  return (
    <div>
      <Component {...props} />
      <div>
        {conditionFn(props) && <Typography>Loading candidates...</Typography>}
      </div>
    </div>
  )
}

const withPaginated = conditionFn => Component => props => (
  <div>
    <Component {...props} />

    <div className="interactions">
      {conditionFn(props) && (
        <div>
          <div>Something went wrong...</div>
          <button type="button" onClick={props.onPaginatedSearch}>
            Try Again
          </button>
        </div>
      )}
    </div>
  </div>
)

const withInfiniteScroll = conditionFn => Component =>
  class WithInfiniteScroll extends React.Component {
    componentDidMount() {
      window.addEventListener('scroll', this.onScroll, false)
    }

    componentWillUnmount() {
      window.removeEventListener('scroll', this.onScroll, false)
    }

    onScroll = () => conditionFn(this.props) && this.props.onPaginatedSearch()

    render() {
      return <Component {...this.props} />
    }
  }

const paginatedCondition = props =>
  props.page !== null && !props.isLoading && props.isError

const infiniteScrollCondition = props =>
  window.innerHeight + window.scrollY >= document.body.offsetHeight - 7000 &&
  props.list.length &&
  !props.isLoading &&
  !props.isError

const loadingCondition = props => props.isLoading

const AdvancedList = compose(
  withPaginated(paginatedCondition),
  withInfiniteScroll(infiniteScrollCondition),
  withLoading(loadingCondition)
)(List)

function mapStateToProps(state) {
  return {
    customer_number: state.customer.number,
    project_id: state.prefix.project_id
  }
}

const mapDispatchToProps = dispatch => {
  return {
    dispatch,
    changeRoute: url => dispatch(push(url)),
    loadedSavedData: data => dispatch(loadedSavedData(data)),
    removeSavedData: () => dispatch(removeSavedData())
  }
}

export default withRouter(
  withStyles(styles, { withTheme: true })(
    connect(mapStateToProps, mapDispatchToProps)(Results)
  )
)



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/scenes/Search/scenes/SavedSearches/scenes/Filters/scenes/ProfileFacts/scenes/Results/index.js